module.exports = __webpack_public_path__ + "fonts/RenaultLife-Italic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Italic.eot
// module id = 355
// module chunks = 0